import script from "./TargetDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./TargetDetails.vue?vue&type=script&lang=ts&setup=true"

import "./TargetDetails.vue?vue&type=style&index=0&id=27ab9196&lang=css"

const __exports__ = script;

export default __exports__